import React, { useState, useEffect,useContext } from 'react';
import { NavLink, Link, useLocation,useNavigate } from 'react-router-dom';
import { RiCloseLargeFill } from "react-icons/ri";
import { FaChevronRight } from "react-icons/fa6";
import { RiHome9Line, RiBuilding2Line, RiShieldUserLine, RiHeadphoneLine, RiHeartLine, RiUserLocationLine, RiInstagramFill, RiFacebookFill, RiYoutubeFill, RiLinkedinFill, RiLogoutCircleRLine } from "react-icons/ri";
import { GrUserWorker } from "react-icons/gr";
import { BsBuildingUp } from "react-icons/bs";
import axios from 'axios';
import { RoleContext } from '../../compontants/pages/Userdatacontext/Datacontexts'; 
import { baseURL } from '../axiosInterceptor/axiosInterceptorC';
import { useSearch } from "../searchContext/SearchContext"; // Import Context
import { useFilter } from "../filterContext/filterContext";
import { LoginPopupContext } from '../loginpopup/LoginPopupContext';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserDetails, fetchPropertyDetails,resetUserState } from '../slice/userSlice';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const path = "/keralaplots/";

function Sidemenu({ onLoginClick, onClose, isSidemenuActive }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { fetchpropertydetails } = useContext(RoleContext);
    const login_id = localStorage.getItem('login_id');
    const { userDetails, CompletedProperties, PendingProperties, loading, error,gettokenval } = useSelector(
        (state) => state.user
      );
      useEffect(() => {
        if (login_id) {
          dispatch(fetchUserDetails(login_id));
          dispatch(fetchPropertyDetails({ login_id, Pstatus: '1' }));
        }
      }, [dispatch, login_id]);

    //const [gettokenval, settokenval] = useState(null);
    const [isShimmerVisible, setIsShimmerVisible] = useState(false);
    const location = useLocation();
    const { setSearchQueryNew } = useSearch();
    const { saveFilterData } = useFilter();

    const isActiveProperty = () => {
        return location.pathname.includes(`/properties`) || location.pathname.includes(`/innerProperty`) ;
    };
    const isActiveBuilder = () => {
        return location.pathname.includes(`/builders`) || location.pathname.includes(`/innerBuilders`) ;
    };
    const isActiveAgent = () => {
        return location.pathname.includes(`/agents`) || location.pathname.includes(`/innerAgent`) ;
    };

    // Side effect to manage shimmer visibility and body overflow
    useEffect(() => {
        if (isSidemenuActive) {
            document.body.style.overflow = 'hidden'; // Hide overflow when sidemenu is active
            setIsShimmerVisible(true); // Show shimmer when sidemenu is active
        } else {
            document.body.style.overflow = 'inherit'; // Restore original overflow when sidemenu is closed
            setIsShimmerVisible(false); // Hide shimmer when sidemenu is closed
        }
    }, [isSidemenuActive]);

    const handleCloseSidemenu = () => {
        setSearchQueryNew(''); 
        const filterData = {
            propertyType: [],  // Only save the selected property type as the first value in the array
            purpose: "",  // Ensure purpose is either set or empty
            selectedDistrict: "",  // Ensure district is either set or empty
            selectedTown: ""  // Ensure town is either set or empty
        };
        saveFilterData(filterData);
       // saveFilterData({ purpose, propertyType, selectedDistrict, selectedTown });
        onClose(); // Close the sidemenu
    };

    //const [gettokenval, settokenval] = useState(null);
   // const [roleval1, setroleval] = useState(null);
    //const [userDetails, setUserDetails] = useState(['']);
    



    const updateToken = () => {
        // const tokenval = localStorage.getItem('jwtToken');
        // settokenval(tokenval || null);
    };

    // const fetchUserDetails = async () => {
    //     const login_id = localStorage.getItem('login_id');
    //     if(login_id != null){
    //     try {
    //         const response = await axios.post(`${baseURL}/fetchuserdetailsid`, {
    //             login_id: login_id,
    //         });
    //         const userdetails=response.data.userdetails[0];
    //             setUserDetails(userdetails);

    //     } catch (error) {
    //         console.error(error);
    //     }
    // }
    // };

    useEffect(() => {
        const jwt_token_val=localStorage.getItem('jwtToken');
        const roleval1=localStorage.getItem('roleval');
        const districtval=localStorage.getItem('districtval');

        //settokenval(jwt_token_val || null);
       // setroleval(roleval1)
        updateToken();
        //fetchUserDetails();
        //fetchPropertyDetails_get(1);
        window.addEventListener('storage', updateToken);
        return () => {
            window.removeEventListener('storage', updateToken);
        };
    }, []);

    const handleLogout = async (e) => {
        e.preventDefault();
              localStorage.removeItem('jwtToken');
              localStorage.removeItem('login_id');
              localStorage.removeItem('roleval');
              localStorage.removeItem('districtval');
              updateToken();
              fetchpropertydetails();
              functionlogout()
              dispatch(resetUserState());
              navigate(path);
              toast.success('Logged out successfully');
                //settokenval(localStorage.removeItem('jwtToken'))
      };


      const functionlogout = async () => {
        try {
            const response = await axios.post(
                'https://keralaplots.com/Official/logoutsession.php',
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }
            );
            console.log(response.data);
        } catch (error) {
        }
    };

// const [CompletedProperties,setCompletedProperties]=useState();
// const [PendingProperties,setPendingProperties]=useState();
// const [inactiveProperties,setinactiveProperties]=useState();
// const fetchPropertyDetails_get = async (Pstatus) => {
//     const login_id = localStorage.getItem('login_id');
//     try {
//     const response = await axios.post(`${baseURL}/fetchPropertyDetails_get`, {
//         login_id: login_id,
//         Pstatus:Pstatus,
//     });
//     setCompletedProperties(response.data.completedCount[0]['total_properties'])
//     setPendingProperties(response.data.pendingdCount[0]['total_properties'])
//     setinactiveProperties(response.data.inactivecount[0]['total_properties'])
 

// }
// catch (error) {
//     console.error(error);
// }
// }

const fetchStoressessionvalues = async (loginId) => {
    try {
        const response = await axios.post(
            'https://keralaplots.com/Official/create_session.php',
            { loginId: loginId },
            {
                headers: {
                    'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
                },
                withCredentials: true, // Include cookies in the request
            }
        );
        console.log(response.data);  // Log the response from the server
    } catch (error) {
        //toast.error(error.response?.data?.error || "An error occurred. Please try again.");
    }
};


const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
  return (
    <>
        {isShimmerVisible && (
            <div className="shimmer"></div>
        )}

        <div className={isSidemenuActive ? "sidemenu sidemenuActive" : "sidemenu"} >
            <div className="closeSidemenu" onClick={handleCloseSidemenu}>
                <RiCloseLargeFill />
            </div>
            <div className="sidemenuHead">
                <div className="sidemenuLogin">
                    <div className="sidemenuLoginCol1">
                        <h2>Hello!</h2>
                        <p>Welcome to Kerala Plots.</p>
                    </div>
                    {!gettokenval && (
                    <div className="sidemenuLoginBtn" onClick={onLoginClick}>Login</div>
                    )}
                </div>
                {gettokenval && (
                <div className="sidemenuProfile">
                    <Link to={`${path}myProfile`} className="sidemenuProfileBox" onClick={handleCloseSidemenu}>
                        <div className="sidemenuProfileBoxThumbnail">
                            <h4>{ userDetails?.userName.charAt(0) || 'Loading...'}</h4>
                        </div>  
                        <div className="sidemenuProfileBoxDetails">
                            <div className="sellerName">{userDetails?.userName || 'Loading...'}</div>
                            <div className="sellerType">{userDetails?.role_val || 'Loading...'}</div> 
                        </div>
                        <div className="sidemenuProfileBoxViewBtn">
                            <FaChevronRight />
                        </div>
                    </Link>
                </div>
                )}
            </div>
            <div className="sidemenuBody">
            {gettokenval && (
                <div className="sidemenuBodyPropertyCounts">
                    <div className="sidemenuBodyPropertyCountsBox uploads">
                        <h3>{PendingProperties}</h3>
                        <p>Uploads</p>
                    </div>
                    <div className="sidemenuBodyPropertyCountsBox sold">
                        <h3>{CompletedProperties}</h3>
                        <p>Sold</p>
                    </div>
                    <div className="sidemenuBodyPropertyCountsBox pending">
                        <h3>{PendingProperties}</h3>
                        <p>Pending</p>
                    </div>
                </div>
                )}
                <div className="sidemenuPostProperty">
                    <a 
                        href="#" 
                        className="sidemenuPostPropertyBtn" 
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default navigation
                            const Tokenval = localStorage.getItem("jwtToken"); 
                            if (!Tokenval) {
                                setIsPopupVisible(true); // Show login popup
                            } else {
                                fetchStoressessionvalues(localStorage.getItem("login_id"));
                                window.open("https://keralaplots.com/keralaplots/postProperty/post-basic-info.html?id=0", "_blank");
                            }
                            handleCloseSidemenu(); // Close the side menu
                        }}
                    >
                        <div className="icon"><BsBuildingUp /></div>
                        <p>Post Your Property</p>
                    </a>
                </div>

                <div className="sidemenuBodyLink">
                    <div className="sidemenuBodyLinkBox">
                        <ul>
                            <li>
                                <NavLink to={`${path}`} onClick={handleCloseSidemenu} end className={({ isActive }) => (isActive ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiHome9Line /></div>
                                    <p>Home</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}properties`} onClick={handleCloseSidemenu} className={() => (isActiveProperty() ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiBuilding2Line /></div>
                                    <p>Properties</p>
                                </NavLink>
                            </li>
                            {gettokenval && (
                            <li>
                                <NavLink to={`${path}savedProperties`} onClick={handleCloseSidemenu} className={({ isActive }) => (isActive ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiHeartLine /></div>
                                    <p>Saved Properties</p>
                                </NavLink>
                            </li>
                             )}
                        </ul>
                    </div>
                    <div className="sidemenuBodyLinkBox">
                        <ul>
                            <li>
                                <NavLink to={`${path}builders`} onClick={handleCloseSidemenu} className={() => (isActiveBuilder() ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><GrUserWorker /></div>
                                    <p>Builders</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}agents`} onClick={handleCloseSidemenu} className={() => (isActiveAgent() ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiUserLocationLine /></div>
                                    <p>Agents</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}aboutUs`} onClick={handleCloseSidemenu} className={({ isActive }) => (isActive ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiShieldUserLine /></div>
                                    <p>About Us</p>
                                </NavLink>
                            </li>
                            {/* <li>
                                <NavLink to={`${path}contact`} onClick={handleCloseSidemenu} className={({ isActive }) => (isActive ? 'sidemenuLinkActive' : '')}>
                                    <div className="icon"><RiHeadphoneLine /></div>
                                    <p>Contact</p>
                                </NavLink>
                            </li> */}
                            {gettokenval && (
                            <li>
                                <NavLink to={path} onClick={handleCloseSidemenu}>
                                    <div className="icon" onClick={handleLogout}><RiLogoutCircleRLine /></div>
                                    <p onClick={handleLogout}>Logout</p>
                                </NavLink>
                            </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="sidemenuFooter">
                <p>Follow us on</p>
                <div className="sidemenuFooterSocialLinks">
                    <Link to="https://www.instagram.com/keralaplots/" target='_blank'><RiInstagramFill /></Link>
                    <Link to="https://www.facebook.com/keralaplots?mibextid=ZbWKwL" target='_blank'><RiFacebookFill /></Link>
                    <Link to="https://youtube.com/@keralaplots1373?si=u5D93SxSFwQ-FmgW" target='_blank'><RiYoutubeFill /></Link>
                    <Link to="https://www.linkedin.com/in/kerala-plots-1a34b6249" target='_blank'><RiLinkedinFill /></Link>
                </div>
            </div>
        </div>
    </>
  );
}

export default Sidemenu;
